import React, { useContext, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Datetime from 'react-datetime';
// import "react-datetime/css/react-datetime.css";

import { Button, Card, Col, Container, Form, ListGroup, Modal, Nav, Row, Tab, Spinner, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import avatar1 from '../../assets/img/avatars/user-avater.webp';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import NotyfContext from '../../contexts/NotyfContext';
import { useDispatch, useSelector } from 'react-redux';
import { blankGeneralInfo, blankNotification, blankPassword, blankPersonalInfo, blankSecurityQuestion, blankSocialProfile, changePasswordApi, deleteAccount, deleteProfilePic, fetchNotification, fetchSecurityQuestion, fetchSocialProfile, postGeneralInfo, postNotificationData, postPersonalInfo, postSecurityQuestionData, postSoclalProfile, setTwoFactorAuth, blankTwoFactorAuth, setProfilePicture, blankDeleteProfileData } from '../../redux/slices/SettingSlice';
import Loader from '../../components/Loader';
import { blankUploadDocument, fetchUploadedDocument } from '../../redux/slices/UploadDocumentSlice';
import moment from 'moment';
import * as Feather from 'react-feather';
import Swal from 'sweetalert2';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import TwoFactorAuth from '../../components/auth/TwoFactorAuth';
import CheckboxTree from 'react-checkbox-tree';
import { setNotifcationBedge } from '../../redux/slices/CommonSlice';
import Joyride from 'react-joyride';
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask';
import { callUserActvity } from '../../redux/slices/CommonSlice';
import { getInitials } from '../../constants';
import InfoPopover from '../../components/new/InfoPopover';
const Navigation = () => {
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: "Here is your progress bar -- you're already on step 2!",
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>And look we're already on a first name basis!</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: 'Open Accounts refers to the total number of active credit accounts you currently have.',
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: 'Negative Accounts are credit accounts with late payments, defaults, or other negative marks on your credit report.',
      disableBeacon: true,
    },
    {
      target: '.fifth-step',
      content: 'Credit Utilization is the percentage of your available credit that you are currently using.',
      disableBeacon: true,
    },
    {
      target: '.sixth-step',
      content: 'Credit Inquiries are the number of times lenders have requested your credit report, which can impact your credit score.',
      disableBeacon: true,
    },
    {
      target: '.seventh-step',
      content: 'Credit History refers to the length of time you have had credit accounts open, which can affect your credit score.',
      disableBeacon: true,
    },
  ];

  React.useEffect(() => {
    setRun(true);
  }, []);

  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const deleteAccountDetail = useSelector(state => state.setting.deleteAccountDetail);
  useEffect(() => {
    if (deleteAccountDetail && Object.keys(deleteAccountDetail).length > 0) {
      if (deleteAccountDetail.error === 0) {
        dispatch(callUserActvity('Account Deleted'));
        notyf.open({
          type: 'success',
          message: 'Account Deleted Successfully.',
          duration: '1500',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        setTimeout(() => {
          signOut();
          navigate('/');
        }, 1500);
      } else {
        notyf.open({
          type: 'danger',
          message: deleteAccountDetail.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [deleteAccountDetail]);
  const handleDeleteAccount = () => {
    dispatch(callUserActvity('Clicked on Delete Account'));
    Swal.fire({
      title: 'Are you sure you want to delete your account?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes, I'm sure.",
      denyButtonText: 'No!  Get me outta here!',
      customClass: {
        confirmButton: 'swal-confirm-button',
        denyButton: 'swal-deny-button',
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.close();
        dispatch(deleteAccount());
      }
    });
  };
  return (
    <Card className='border-0 shadow py-3'>
      {/* <Joyride showSkipButton={true} locale={{ last: 'FINISH'}} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={true} /> */}
      <Nav variant='pills' className='flex-md-column gap-3'>
        <Nav.Item>
          <Nav.Link className='text-secondary border-primary border-start-0 border-bottom-0 border-top-0 rounded-0 d-flex align-items-center first-step' eventKey='general'>
            <Feather.Grid size={17} className='me-1' /> General
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className='text-secondary border-primary border-start-0 border-bottom-0 border-top-0 rounded-0 d-flex align-items-center' eventKey='personal_info'>
            <Feather.User size={17} className='me-1' /> Personal Information
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className='text-secondary border-primary border-start-0 border-bottom-0 border-top-0 rounded-0 d-flex align-items-center' eventKey='password'>
            <Feather.Shield size={17} className='me-1' /> Security
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className='d-none'>
          <Nav.Link className='text-secondary border-primary border-start-0 border-bottom-0 border-top-0 rounded-0 d-flex align-items-center' eventKey='social_profiles'>
            <Feather.Link size={17} className='me-1' /> Social Profiles
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className='text-secondary border-primary border-start-0 border-bottom-0 border-top-0 rounded-0 d-flex align-items-center' eventKey='notification'>
            <Feather.Bell size={17} className='me-1' /> Notifications
          </Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
              <Nav.Link eventKey="security">Security</Nav.Link>
            </Nav.Item> */}
        <Nav.Item>
          <Nav.Link className='text-danger d-none d-md-block d-flex align-items-center' onClick={() => handleDeleteAccount()}>
            <Feather.Trash size={17} className='me-1' />
            Delete Account
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </Card>
  );
};

const GeneralInfo = () => {
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const postGeneralData = useSelector(state => state.setting.postGeneralData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const trackFormChangeGeneralInfo = useRef(false);
  const [userInfo, setUserInfo] = useState({
    name: '',
    salutation: '',
    address: '',
    phone: '',
    email: '',
  });
  useEffect(() => {
    if (uploadDocumentStatus === 'idle') {
      dispatch(fetchUploadedDocument());
    }
  }, [uploadDocumentStatus, dispatch]);
  useEffect(() => {
    if (userCurrentInfo && Object.keys(userCurrentInfo).length > 0) {
      if (userCurrentInfo.error === 0) {
        setUserInfo({
          name: (userCurrentInfo.response.client_fname && userCurrentInfo.response.client_fname !== '') || (userCurrentInfo.response.client_fname && userCurrentInfo.response.client_fname !== '') ? userCurrentInfo.response.client_fname + ' ' + userCurrentInfo.response.client_lname : '',
          salutation: userCurrentInfo.response.title && userCurrentInfo.response.title !== '' ? userCurrentInfo.response.title : '',
          address: userCurrentInfo.response.address1 || '',
          address2: userCurrentInfo.response.address2 || '',
          country: userCurrentInfo.response.country || '',
          state: userCurrentInfo.response.state || '',
          zip: userCurrentInfo.response.zip || '',
          phone: userCurrentInfo.response.primary_phone && userCurrentInfo.response.primary_phone !== '' ? userCurrentInfo.response.primary_phone : '',
          email: userCurrentInfo.response.client_email && userCurrentInfo.response.client_email !== '' ? userCurrentInfo.response.client_email : '',
        });
      }
    }
  }, [userCurrentInfo]);
  useEffect(() => {
    if (postGeneralData && Object.keys(postGeneralData).length > 0) {
      if (postGeneralData.error === 0) {
        dispatch(blankGeneralInfo());
        dispatch(blankUploadDocument());
        dispatch(callUserActvity('Settings - General Information saved'));
        notyf.open({
          type: 'success',
          message: 'General Info Updated successfully.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: postGeneralData.msg || postGeneralData.data,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(blankGeneralInfo());
      }
    }
  }, [postGeneralData]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userInfo.name,
      salutation: userInfo.salutation,
      address: userInfo.address,
      address2: userInfo.address2,
      country: userInfo.country,
      state: userInfo.state,
      zip: userInfo.zip,
      phone: userInfo.phone,
      email: userInfo.email,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().max(255).required('Name is required'),
      salutation: Yup.string().max(255).required('Salutation is required'),
      address: Yup.string().max(255).required('Address is required'),
      country: Yup.string().max(255).required('City is required'),
      state: Yup.string().max(255).required('State is required'),
      zip: Yup.string().max(255).required('Zip is required'),
      phone: Yup.number().typeError("That doesn't look like a phone number").positive("A phone number can't start with a minus").integer("A phone number can't include a decimal point").required('A phone number is required'),
    }),
    onSubmit: async values => {
      let obj = {
        full_name: values.name,
        title: values.salutation,
        address: values.address,
        address2: values.address2,
        country: values.country,
        state: values.state,
        zip: values.zip,
        phone_nu: values.phone,
      };
      dispatch(postGeneralInfo(obj));
    },
  });
  useEffect(() => {
    return () => {
      // if(trackFormChangeGeneralInfo.current){
      //   if(!window.confirm("Are you sure you want to leave")){
      //     return;
      //   }
      // }
      // //console.log("here 230");
    };
  }, []);
  if (uploadDocumentStatus === 'loading') {
    return <Loader />;
  }
  const phoneMask = createDefaultMaskGenerator('(999) 999 9999');
  trackFormChangeGeneralInfo.current = formik.dirty;
  return (
    <Card className='border-0 shadow p-4 rounded'>
      <Card.Body>
        <h3 className='mb-3'>General</h3>
        <Form onSubmit={formik.handleSubmit}>
          <Row className='d-flex flex-column'>
            <Col md='6'>
              <Form.Check type='radio' id='salutation_1' name='salutation' value='1' label='Mr' inline className='mt-4 mb-3' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.salutation && formik.errors.salutation)} checked={formik.values.salutation == '1' ? true : false} />
              <Form.Check type='radio' id='salutation_2' name='salutation' value='2' label='Mrs' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.salutation && formik.errors.salutation)} checked={formik.values.salutation == '2' ? true : false} />
              <Form.Check type='radio' id='salutation_3' name='salutation' value='3' label='Miss' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.salutation && formik.errors.salutation)} checked={formik.values.salutation == '3' ? true : false} />
            </Col>
            <Col md='6'>
              <Form.Group className='mb-3'>
                <Form.Label>Name</Form.Label>
                <Form.Control type='text' name='name' id='name' placeholder='Name' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name} isInvalid={Boolean(formik.touched.name && formik.errors.name)} />
                {!!formik.touched.name && <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs='6'>
              <Form.Group className='mb-3'>
                <Form.Label>Email</Form.Label>
                <Form.Control type='text' name='email' id='email' value={formik.values.email} placeholder='Email' size='lg' readOnly />
              </Form.Group>
            </Col>
            <Col xs='6'>
              <Form.Group className='mb-3'>
                <Form.Label>Phone Number</Form.Label>
                <MaskedInput
                  maskGenerator={phoneMask}
                  type='text'
                  id='phone'
                  name='phone'
                  className={`form-control form-control-lg ${Boolean(formik.touched.phone && formik.errors.phone) ? 'is-invalid' : ''}`}
                  placeholder='(123) 456 7890'
                  size='lg'
                  onChange={e => {
                    formik.setFieldValue('phone', e);
                  }}
                  value={formik.values.phone}
                  isInvalid={Boolean(formik.touched.phone && formik.errors.phone)}
                  onBlur={formik.handleBlur}
                />
                {!!formik.touched.phone && <Form.Control.Feedback type='invalid'>{formik.errors.phone}</Form.Control.Feedback>}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Form.Group className='col-lg-8 mb-3'>
              <Form.Label className='text-light-gray form-label'>Address Line 1</Form.Label>
              <Form.Control type='text' name='address' id='address' placeholder='Address' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address} isInvalid={Boolean(formik.touched.address && formik.errors.address)} />
              {!!formik.touched.address && <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>}
            </Form.Group>
            <Form.Group className='col-lg-4 mb-3'>
              <Form.Label className='text-light-gray form-label'>Address Line 2</Form.Label>
              <Form.Control type='text' name='address2' id='address2' placeholder='Address 2 (Optional)' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address2} />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className='col-lg-6 mb-3'>
              <Form.Label className='text-light-gray form-label'>City</Form.Label>
              <Form.Control type='text' name='country' id='country' placeholder='City' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.country} isInvalid={Boolean(formik.touched.country && formik.errors.country)} />
              {!!formik.touched.country && <Form.Control.Feedback type='invalid'>{formik.errors.country}</Form.Control.Feedback>}
            </Form.Group>
            <Form.Group className='col-lg-2 mb-3'>
              <Form.Label className='text-light-gray form-label'>State</Form.Label>
              <Form.Control type='text' name='state' id='state' placeholder='State' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.state} isInvalid={Boolean(formik.touched.state && formik.errors.state)} />
              {!!formik.touched.state && <Form.Control.Feedback type='invalid'>{formik.errors.state}</Form.Control.Feedback>}
            </Form.Group>
            <Form.Group className='col-lg-4 mb-3'>
              <Form.Label className='text-light-gray form-label'>Zip Code</Form.Label>
              <Form.Control type='text' name='zip' id='zip' placeholder='Zip' size='lg' autoComplete='new-password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.zip} isInvalid={Boolean(formik.touched.zip && formik.errors.zip)} />
              {!!formik.touched.zip && <Form.Control.Feedback type='invalid'>{formik.errors.zip}</Form.Control.Feedback>}
            </Form.Group>
          </Row>

          <Button type='submit' variant='primary' className='mt-3'>
            Save changes
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

const PersonalInfo = () => {
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const postPersonalData = useSelector(state => state.setting.postPersonalData);
  const setProfileImageData = useSelector(state => state.setting.setProfileImageData);
  const personalInfoStatus = useSelector(state => state.setting.personalInfoStatus);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const [userPersonalInfo, setUserPersonalInfo] = useState({
    marital_status: '',
    name: '',
    dob: '',
    kids: '',
    about_me: '',
    job: '',
    income: '',
    profile_path: '',
    age: '',
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [profilePicLink, setProfilePicLink] = useState(null);
  useEffect(() => {
    if (uploadDocumentStatus === 'idle') {
      dispatch(fetchUploadedDocument());
    }
  }, [uploadDocumentStatus, dispatch]);
  useEffect(() => {
    if (userCurrentInfo && Object.keys(userCurrentInfo).length > 0) {
      if (userCurrentInfo.error === 0) {
        setUserPersonalInfo({
          marital_status: userCurrentInfo.response.marital_status,
          dob: userCurrentInfo.response.dob ? moment(userCurrentInfo.response.dob) : null,
          kids: userCurrentInfo.response.kids ? userCurrentInfo.response.kids : '',
          about_me: userCurrentInfo.response.about_me ? userCurrentInfo.response.about_me : '',
          job: userCurrentInfo.response.job ? userCurrentInfo.response.job : '',
          income: userCurrentInfo.response.income ? userCurrentInfo.response.income : '',
          profile_path: userCurrentInfo.response.profile_img,
          age: userCurrentInfo.response.dob ? userCurrentInfo.response.age : '',
          name: userCurrentInfo.response.client_fname + ' ' + userCurrentInfo.response.client_lname,
        });
        setSelectedDate(userCurrentInfo.response.dob ? new Date(userCurrentInfo.response.dob) : null);
      }
    }
  }, [userCurrentInfo]);
  useEffect(() => {
    if (postPersonalData && Object.keys(postPersonalData).length > 0) {
      if (postPersonalData.error === 0) {
        dispatch(blankPersonalInfo());
        dispatch(blankUploadDocument());
        dispatch(fetchNotification());
        dispatch(setNotifcationBedge(true));
        dispatch(callUserActvity('Settings - Personal Information saved'));
        notyf.open({
          type: 'success',
          message: 'Personal Updated successfully.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: postPersonalData.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [postPersonalData]);

  useEffect(() => {
    if (setProfileImageData && Object.keys(setProfileImageData).length > 0) {
      if (setProfileImageData.error === 0) {
        dispatch(blankUploadDocument());
      }
    }
  }, [setProfileImageData]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      marital_status: userPersonalInfo.marital_status,
      kids: userPersonalInfo.kids,
      dob: userPersonalInfo.dob ? moment(userPersonalInfo.dob).format('YYYY-MM-DD') : '',
      about_me: userPersonalInfo.about_me,
      job: userPersonalInfo.job,
      income: userPersonalInfo.income,
    },
    validationSchema: Yup.object().shape({
      marital_status: Yup.string().max(255).required('Marital Status is required'),
      kids: Yup.string().max(255).required('Kids is required'),
      about_me: Yup.string().max(255).required('About Me is required'),
      job: Yup.string().max(255).required('Job is required'),
      dob: Yup.string().max(10).max(11).required('Date of birth is required'),
      income: Yup.string().max(255).required('Income is required'),
    }),
    onSubmit: async values => {
      let obj = {
        marital_status: values.marital_status,
        kids: values.kids,
        about_me: values.about_me,
        job: values.job,
        income: values.income,
        dob: moment(values.dob).format('YYYY-MM-DD'),
        profile_img: profilePic,
      };
      dispatch(postPersonalInfo(obj));
    },
  });



  const SUPPORTED_FORMATS = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
  const changeFileUpload = e => {
    if (e.target.files && e.target.files.length > 0) {
      const fileExtension = e.target.files[0].name.split('.').at(-1);
      if (SUPPORTED_FORMATS.includes(fileExtension)) {
        // setProfilePic(e.target.files[0]);
        // const reader = new FileReader();
        // reader.addEventListener('load', () => setProfilePicLink(reader.result));
        // reader.readAsDataURL(e.target.files[0]);
        dispatch(setProfilePicture(e.target.files[0]));
      } else {
        notyf.open({
          type: 'danger',
          message: 'Only png,jpg and jpeg allowed',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
      e.target.value = '';
    }
  };

  const deleteProfileData = useSelector(state => state.setting.deleteProfileData);
  useEffect(() => {
    if (deleteProfileData && Object.keys(deleteProfileData).length > 0) {
      if (deleteProfileData.error === 0) {
        dispatch(blankPersonalInfo());
        dispatch(blankUploadDocument());
        notyf.open({
          type: 'success',
          message: 'Profile Pic Deleted Successfully',
          duration: '1500',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: deleteProfileData.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
      dispatch(blankDeleteProfileData());
    }
  }, [deleteProfileData]);

  const handleDeleteProfilePic = () => {
    Swal.fire({
      title: 'Are you sure you want to delete profile image ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then(result => {
      if (result.isConfirmed) {
        Swal.close();
        dispatch(deleteProfilePic());
      }
    });
  };
  const profilePath = userCurrentInfo?.response?.profile_img || '';
  const basePath = document.body.dataset['app_base_url'];
  const fullProfileImgUrl = profilePath ? (profilePath?.includes('https://') ? profilePath : basePath + profilePath) : null;
  const avatarUrl = fullProfileImgUrl;
  // Access profile path from Redux state


  return (
    <Card className='border-0 shadow p-4 rounded position-relative'>
      <Card.Body>
        <h3 className='mb-5'>Personal Information</h3>
        <Form onSubmit={formik.handleSubmit}>
          <Row className='mb-4 align-items-center'>
            <Col md='2' className='text-center'>
              {personalInfoStatus === 'loading' ? (
                <div className='d-flex align-items-center justify-content-center' style={{ width: 100, height: 100 }}>
                  <Loader sm={true} />
                </div>
              ) : (avatarUrl && avatarUrl !== '') || profilePicLink ? (
                <img src={`${fullProfileImgUrl || basePath + avatarUrl}`} alt='User Profile Image' className='rounded-circle img-responsive mt-2' width='100' height='100' style={{ objectFit: 'cover' }} />
              ) : (
                <div className='d-flex justify-content-center align-items-center'>
                  <span
                    className='avatar-initials img-fluid rounded-circle me-1 border border-2 border-primary text-primary bg-white'
                    style={{
                      width: 100,
                      height: 100,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '16px',
                      fontWeight: 'normal',
                      objectFit: 'cover',
                    }}>
                    {getInitials(localStorage.getItem('username'))}
                  </span>
                </div>
              )}
            </Col>

            <Col md='3'>
              <Button variant='light' className='text-primary'>
                <Form.Label htmlFor='profile_image' className='mb-0 pb-0'>
                  Upload new Photo
                  <Form.Control hidden type='file' name='profile_image' id='profile_image' onChange={e => changeFileUpload(e)} />
                </Form.Label>
              </Button>
            </Col>
            <Col md='2'>
              <Button variant='light' className='text-danger' type='button' disabled={!profilePath || profilePath === ''} onClick={() => handleDeleteProfilePic()}>
                Delete Photo
              </Button>
            </Col>
          </Row>
          <Form.Group className='mb-4'>
            <p className='text-muted'>Marital Status</p>
            <Form.Check type='radio' name='marital_status' value='1' label='Married' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.marital_status && formik.errors.marital_status)} checked={formik.values.marital_status && formik.values.marital_status == '1' ? true : false} />
            <Form.Check type='radio' name='marital_status' value='2' label='Single' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.marital_status && formik.errors.marital_status)} checked={formik.values.marital_status && formik.values.marital_status == '2' ? true : false} />
            <Form.Check type='radio' name='marital_status' value='3' label='Divorced' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.marital_status && formik.errors.marital_status)} checked={formik.values.marital_status && formik.values.marital_status == '3' ? true : false} />
            <Form.Check type='radio' name='marital_status' value='4' label='Widowed' inline size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.marital_status && formik.errors.marital_status)} checked={formik.values.marital_status && formik.values.marital_status == '4' ? true : false} />
          </Form.Group>
          <Row>
            <Form.Group className='col-12 col-md-4 mb-4'>
              <Form.Label>Date of birth</Form.Label>
              <Form.Control type='date' name='dob' id='dob' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.dob} isInvalid={Boolean(formik.touched.dob && formik.errors.dob)} />
              {!!formik.touched.dob && <Form.Control.Feedback type='invalid'>{formik.errors.dob}</Form.Control.Feedback>}
            </Form.Group>

            <Form.Group className='col-12 col-md-4 mb-4'>
              <Form.Label>Kids</Form.Label>
              <Form.Control type='text' name='kids' id='kids' placeholder='Kids' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.kids} isInvalid={Boolean(formik.touched.kids && formik.errors.kids)} />
              {!!formik.touched.kids && <Form.Control.Feedback type='invalid'>{formik.errors.kids}</Form.Control.Feedback>}
            </Form.Group>

            <Form.Group className='col-12 col-md-4 mb-4'>
              <Form.Label>Job</Form.Label>
              <Form.Control type='text' name='job' id='job' placeholder='Job' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.job} isInvalid={Boolean(formik.touched.job && formik.errors.job)} />
              {!!formik.touched.job && <Form.Control.Feedback type='invalid'>{formik.errors.job}</Form.Control.Feedback>}
            </Form.Group>
          </Row>

          <Form.Group className='mb-4'>
            <Form.Label>About Me</Form.Label>
            <Form.Control as='textarea' name='about_me' id='about_me' placeholder='About Me' rows={2} size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.about_me} isInvalid={Boolean(formik.touched.about_me && formik.errors.about_me)} />
            {!!formik.touched.about_me && <Form.Control.Feedback type='invalid'>{formik.errors.about_me}</Form.Control.Feedback>}
          </Form.Group>
          <Row className='mb-5'>
            <Form.Group className='col-12 col-md-12'>
              <Form.Label>Income</Form.Label>
              <Form.Control type='text' name='income' id='income' placeholder='Income' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.income} isInvalid={Boolean(formik.touched.income && formik.errors.income)} />
              {!!formik.touched.income && <Form.Control.Feedback type='invalid'>{formik.errors.income}</Form.Control.Feedback>}
            </Form.Group>
          </Row>

          <Button type='submit' variant='primary'>
            Save changes
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

const SocialProfile = () => {
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const getSocialProfie = useSelector(state => state.setting.getSocialProfie);
  const postSocialProfile = useSelector(state => state.setting.postSocialProfile);
  const socialProfileStatus = useSelector(state => state.setting.socialProfileStatus);
  const socialProfileError = useSelector(state => state.setting.socialProfileError);
  const [socialLinks, setSocialLinks] = useState({
    facebook: '',
    twitter: '',
  });
  useEffect(() => {
    if (socialProfileStatus === 'idle') {
      dispatch(fetchSocialProfile());
    }
  }, [socialProfileStatus, dispatch]);
  const trackFormChange = useRef(false);

  useEffect(() => {
    if (postSocialProfile && Object.keys(postSocialProfile).length > 0) {
      if (postSocialProfile.error === 0) {
        dispatch(blankSocialProfile());
        dispatch(callUserActvity('Settings - Social profiles saved'));
        notyf.open({
          type: 'success',
          message: 'Social Links Updated successfully.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: postSocialProfile.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [postSocialProfile]);

  useEffect(() => {
    if (getSocialProfie && Object.keys(getSocialProfie).length > 0) {
      if (getSocialProfie.error === 0) {
        setSocialLinks({
          twitter: getSocialProfie.data.social_links.twitter_handle || '',
          facebook: getSocialProfie.data.social_links.facebook_handle || '',
        });
      }
    }
  }, [getSocialProfie]);

  useEffect(() => {
    if (getSocialProfie && Object.keys(getSocialProfie).length > 0) {
      if (getSocialProfie.error === 0) {
        setSocialLinks({
          twitter: getSocialProfie.data.social_links.twitter_link,
          facebook: getSocialProfie.data.social_links.facebook_link,
        });
      }
    }
  }, [getSocialProfie]);
  const re = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      facebook_link: socialLinks.facebook || '',
      twitter_link: socialLinks.twitter || '',
    },
    validationSchema: Yup.object().shape(
      {
        facebook_link: Yup.string()
          .max(255)
          .when(['twitter_link'], {
            is: twitter_link => !twitter_link || twitter_link?.length <= 0,
            then: Yup.string().matches(re, 'Enter Your Valid Facebook Profile Link').required('Facebook Link is required'),
          })
          .ensure(),
        twitter_link: Yup.string()
          .max(255)
          .when(['facebook_link'], {
            is: facebook_link => !facebook_link || facebook_link?.length <= 0,
            then: Yup.string().matches(re, 'Enter Your Valid Twitter Profile Link').required('Twitter Link is required'),
          })
          .ensure(),
      },
      [['twitter_link', 'facebook_link']]
    ),
    onSubmit: async values => {
      let obj = {
        twitter_link: values.twitter_link,
        facebook_link: values.facebook_link,
      };
      dispatch(postSoclalProfile(obj));
    },
  });
  // //console.log("hereeee=>",formik.dirty);
  useEffect(() => {
    return () => {
      // if(trackFormChange.current){
      //   alert("Are you sure you want to leave");
      // }
    };
  }, []);
  if (socialProfileStatus === 'loading') {
    return <Loader />;
  }
  if (socialProfileStatus === 'failed') {
    notyf.open({
      type: 'danger',
      message: socialProfileError,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }
  trackFormChange.current = formik.dirty;
  return (
    <Card className='border-0 shadow p-4 rounded'>
      <Card.Body>
        <h3 className='mb-5'>Social Profiles</h3>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label>Twitter</Form.Label>
            <Form.Control type='text' name='twitter_handle' id='twitter_handle' placeholder='Twitter Handle' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.twitter_handle} isInvalid={Boolean(formik.touched.twitter_handle && formik.errors.twitter_handle)} />

            {!!formik.touched.twitter_link && <Form.Control.Feedback type='invalid'>{formik.errors.twitter_link}</Form.Control.Feedback>}
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Facebook</Form.Label>
            <Form.Control type='text' name='facebook_handle' id='facebook_handle' placeholder='Facebook Handle' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.facebook_handle} isInvalid={Boolean(formik.touched.facebook_handle && formik.errors.facebook_handle)} />

            {!!formik.touched.facebook_link && <Form.Control.Feedback type='invalid'>{formik.errors.facebook_link}</Form.Control.Feedback>}
          </Form.Group>
          {/* <Form.Group>
            <Form.Label>Google</Form.Label>
            <br />
            <Button variant='primary' size='md'>
              Google
            </Button>
          </Form.Group> */}

          <Button variant='primary' className='mt-5' type='submit'>
            Save changes
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

const NotificationPage = () => {
  const nodesOld = [
    {
      value: 'mars',
      label: 'Mars',
      showCheckbox: true,
      children: [
        { value: 'phobos', label: 'Phobos', showCheckbox: true },
        { value: 'deimos', label: 'Deimos', showCheckbox: true },
      ],
    },
  ];
  function getNodeIds(nodes) {
    let ids = [];
    if (nodes) {
      nodes.forEach(({ value, children }) => {
        ids = [...ids, value, ...getNodeIds(children)];
      });
    }
    return ids;
  }
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const getNotification = useSelector(state => state.setting.getNotification);
  const postNotification = useSelector(state => state.setting.postNotification);
  const notificationStatus = useSelector(state => state.setting.notificationStatus);
  const notificationError = useSelector(state => state.setting.notificationError);
  const [notifyWhen, setNotifyWhen] = useState([]);
  const [smsSendBy, setSmsSendBy] = useState(0);
  const [emailSendBy, setEmailSendBy] = useState(0);
  const [nodes, setNodes] = useState([]);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [allNodeId, setAllNodeId] = useState([]);
  let allNotification = [];

  useEffect(() => {
    if (notificationStatus === 'idle') {
      dispatch(fetchNotification());
    }
  }, [notificationStatus, dispatch]);
  useEffect(() => {
    if (postNotification && Object.keys(postNotification).length > 0) {
      if (postNotification.error === 0) {
        dispatch(blankNotification());
        dispatch(callUserActvity('Settings - Notifications updated'));
        notyf.open({
          type: 'success',
          message: 'Notification Updated successfully.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: postNotification.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [postNotification]);

  const selectAllNotifyWhen = () => {
    if (checked.length) setChecked([]);
    else setChecked(allNodeId);
  };
  const handleClickSendBy = e => {
    if (e.target.value === 'bymail') {
      setEmailSendBy(emailSendBy === 0 ? 1 : 0);
    }
    if (e.target.value === 'bysms') {
      setSmsSendBy(smsSendBy === 0 ? 1 : 0);
    }
  };
  const handleSubmit = () => {
    // let message = '';
    // if (checked.length === 0) {
    //   message = 'Please select atleast one notify me when.';
    // }
    // if (smsSendBy == 0 && emailSendBy == 0) {
    //   message = 'Please select atleast one send me.';
    // }
    // if (message !== '') {
    //   notyf.open({
    //     type: 'danger',
    //     message: message,
    //     duration: '3000',
    //     ripple: false,
    //     dismissible: false,
    //     position: {
    //       x: 'right',
    //       y: 'top',
    //     },
    //   });
    //   return;
    // }
    let obj = {
      selected_items: checked,
      sms: smsSendBy,
      email: emailSendBy,
    };
    dispatch(postNotificationData(obj));
  };
  useEffect(() => {
    if (getNotification && Object.keys(getNotification).length > 0) {
      if (getNotification.error === 0) {
        setEmailSendBy(eval(getNotification.data.email));
        setSmsSendBy(eval(getNotification.data.sms));
        setNotifyWhen(getNotification.data.selected_notification);
        const notification_categories = getNotification.data.notification_categories;
        const notification_events = getNotification.data.notification_events;
        let nodesOri = [];
        let allNodeIds = [];
        notification_categories?.map(data => {
          let notificationArr = notification_events.filter(item => item.notification_category === data.id);
          let obj = {
            value: data.id + '_' + data.category_title,
            label: <><InfoPopover key={data.id} headerContent={""} bodyContent={data.category_description} /> {data.category_title} </> ,
            showCheckbox: true,
          };
          let childrenArr = [];
          notificationArr.map(notyData => {
            let objIn = {
              value: notyData.id,
              label: notyData.description,
              showCheckbox: true,
            };
            childrenArr.push(objIn);
            allNodeIds.push(notyData.id);
          });
          obj.children = childrenArr;
          nodesOri.push(obj);
        });
        setNodes(nodesOri);
        setAllNodeId(allNodeIds);
        // setExpanded(getNodeIds(nodesOri));

        //checked
        const selected_notification = getNotification.data.selected_notification;
        setChecked(selected_notification);
      }
    }
  }, [getNotification]);
  if (notificationStatus === 'loading') {
    return <Loader />;
  }

  // //console.log('checked->', checked);
  return (
    <Card className='border-0 shadow p-4 rounded'>
      <Card.Body>
        <h3 className='mb-5'>Notifications</h3>
        <Form>
          <Form.Group className='mb-3'>
            <p className='text-muted'>Send Me</p>
            <Form.Check type='checkbox' id='bymail' name='bymail' value='bymail' label='By Email' inline size='lg' onClick={e => handleClickSendBy(e)} checked={emailSendBy === 0 ? false : true} />
            <Form.Check type='checkbox' id='bysms' name='bysms' value='bysms' label='By SMS' inline size='lg' onClick={e => handleClickSendBy(e)} checked={smsSendBy === 0 ? false : true} />
          </Form.Group>
          <style>
            {`
            .rct-title {
	margin-left: 1rem;
}
            `}
          </style>
          <Form.Group>
            <div className='d-flex justify-content-between'>
              <Form.Label>Notify Me When </Form.Label>
              {/* <Button variant='link' disabled={!emailSendBy && !smsSendBy} onClick={() => selectAllNotifyWhen()}>
                Toogle All
              </Button> */}
            </div>
            <CheckboxTree disabled={!emailSendBy && !smsSendBy} nodes={nodes} checked={checked} expanded={expanded} onCheck={checked => setChecked(checked)} onExpand={expanded => setExpanded(expanded)} />
          </Form.Group>

          <Button variant='primary' className='mt-5' size='lg' type='button' onClick={() => handleSubmit()}>
            Save changes
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

const PasswordInfo = () => {
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const changePassword = useSelector(state => state.setting.changePassword);
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    verifyPassword: false,
  });
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const twoFactorAuthStatus = useSelector(state => state.setting.twoFactorAuthStatus);

  useEffect(() => {
    if (changePassword && Object.keys(changePassword).length > 0) {
      if (changePassword.error == 0) {
        dispatch(callUserActvity('Settings - Password changed'));
        notyf.open({
          type: 'success',
          message: 'Change Password successfully',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(blankPassword());
      } else {
        notyf.open({
          type: 'danger',
          message: changePassword.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [changePassword]);

  useEffect(() => {
    if (twoFactorAuthStatus === 'succeeded') {
      dispatch(blankUploadDocument());
      dispatch(blankTwoFactorAuth());
    }
  }, [twoFactorAuthStatus]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      current_password: '',
      new_password: '',
      verify_password: '',
    },
    validationSchema: Yup.object().shape({
      current_password: Yup.string()
      // .required('Current is required')
      .max(255),
      new_password: Yup.string().min(6, 'Must be at least 6 characters').max(255).required('New Password is Required'),
      verify_password: Yup.string()
        .min(6, 'Must be at least 6 characters')
        .max(255)
        .required('Verify password required')
        .oneOf([Yup.ref('new_password'), null], 'Passwords must match'),
    }),
    onSubmit: async values => {
      let obj = {
        new_password: values.new_password,
        old_password: values.current_password,
      };
      dispatch(changePasswordApi(obj));
    },
  });

  const handleShowPassword = type => {
    const showPasswordOri = { ...showPassword };
    if (type === 'currentPassword') {
      showPasswordOri.currentPassword = !showPasswordOri.currentPassword;
    }
    if (type === 'newPassword') {
      showPasswordOri.newPassword = !showPasswordOri.newPassword;
    }
    if (type === 'verifyPassword') {
      showPasswordOri.verifyPassword = !showPasswordOri.verifyPassword;
    }
    setShowPassword(showPasswordOri);
  };

  return (
    <Card className='border-0 shadow p-4 rounded'>
      <Card.Body>
        <h3 className='mb-5'>Security</h3>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label htmlFor='current_password'>Current Password</Form.Label>
            <div className='position-relative'>
              <Form.Control size='lg' type={`${!showPassword.currentPassword ? 'password' : 'text'}`} name='current_password' id='current_password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.current_password} isInvalid={Boolean(formik.touched.current_password && formik.errors.current_password)} />
              <span className='position-absolute top-50 end-0 translate-middle-y text-dark-blue' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => handleShowPassword('currentPassword')}>
                {!showPassword.currentPassword ? <Feather.Eye size='20' /> : <Feather.EyeOff size='20' />}
              </span>
            </div>

            {!!formik.touched.current_password && <Form.Control.Feedback type='invalid'>{formik.errors.current_password}</Form.Control.Feedback>}
          </Form.Group>

          <Row>
            <Form.Group className='col-md-6 col-12 mb-3'>
              <Form.Label htmlFor='new_password'>New Password</Form.Label>
              <div className={`position-relative ${Boolean(formik.touched.new_password && formik.errors.new_password) && 'is-invalid'}`}>
                <Form.Control size='lg' type={`${!showPassword.newPassword ? 'password' : 'text'}`} name='new_password' id='new_password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.new_password} isInvalid={Boolean(formik.touched.new_password && formik.errors.new_password)} />
                <span className='position-absolute top-50 end-0 translate-middle-y text-dark-blue' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => handleShowPassword('newPassword')}>
                  {!showPassword.newPassword ? <Feather.Eye size='20' /> : <Feather.EyeOff size='20' />}
                </span>
              </div>

              {!!formik.touched.new_password && <Form.Control.Feedback type='invalid'>{formik.errors.new_password}</Form.Control.Feedback>}
            </Form.Group>

            <Form.Group className='col-md-6 col-12 mb-3'>
              <Form.Label htmlFor='verify_password'>Verify Password</Form.Label>
              <div className={`position-relative ${Boolean(formik.touched.verify_password && formik.errors.verify_password) && 'is-invalid'}`}>
                <Form.Control size='lg' type={`${!showPassword.verifyPassword ? 'password' : 'text'}`} name='verify_password' id='verify_password' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.verify_password} isInvalid={Boolean(formik.touched.verify_password && formik.errors.verify_password)} />
                <span className='position-absolute top-50 end-0 translate-middle-y text-dark-blue' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => handleShowPassword('verifyPassword')}>
                  {!showPassword.verifyPassword ? <Feather.Eye size='20' /> : <Feather.EyeOff size='20' />}
                </span>
              </div>

              {!!formik.touched.verify_password && <Form.Control.Feedback type='invalid'>{formik.errors.verify_password}</Form.Control.Feedback>}
            </Form.Group>
          </Row>

          <Button variant='primary' type='submit'>
            Update Password
          </Button>

          <div className='mt-5'>
            <h4>Two-factor authentication</h4>
            <p>Two-factor authentication protects your account from malicious activity by verifying you are in possession of a registered device on each login attempt.</p>
            <div className='mb-3'>
              {[null, 1, undefined, '1'].includes(userCurrentInfo?.response?.enable_2fa) ? (
                <button
                  type='button'
                  onClick={() => {
                    dispatch(setTwoFactorAuth(0));

                    // (async () => await setTwoFactorAuth(0, () => dispatch(blankUploadDocument())))()
                  }}
                  className='btn btn-outline-danger'>
                  Disable Two-factor authentication
                </button>
              ) : (
                <button
                  type='button'
                  onClick={() => {
                    dispatch(setTwoFactorAuth(1));
                  }}
                  className='btn btn-outline-primary'>
                  Enable Two-factor authentication
                </button>
              )}
            </div>
          </div>

          
        </Form>
      </Card.Body>
    </Card>
  );
};

const Setting = () => {
  const dispatch = useDispatch();
  const handleDeleteAccount = () => {
    dispatch(callUserActvity('Settings - Delete Account clicked'));
    Swal.fire({
      title: 'Are you sure you want to delete this account ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then(result => {
      if (result.isConfirmed) {
        Swal.close();
        dispatch(deleteAccount());
      }
    });
  };

  return (
    <React.Fragment>
      <Helmet title='Settings' />
      <Container className='p-0'>
        <Tab.Container unmountOnExit={true} mountOnEnter={false} transition={false} id='list-group-tabs-example' defaultActiveKey='general'>
          <Row>
            <Col md='3' xl='2' className='first-step'>
              <Navigation />
            </Col>
            <Col md='9' xl='10'>
              <Tab.Content>
                <Tab.Pane eventKey='general'>
                  <GeneralInfo />
                </Tab.Pane>
                <Tab.Pane eventKey='personal_info'>
                  <PersonalInfo />
                </Tab.Pane>
                <Tab.Pane eventKey='password'>
                  <PasswordInfo />
                </Tab.Pane>
                <Tab.Pane eventKey='social_profiles'>
                  <SocialProfile />
                </Tab.Pane>
                <Tab.Pane eventKey='notification'>
                  <NotificationPage />
                </Tab.Pane>
                {/* <Tab.Pane eventKey="security">
                                <Security />
                            </Tab.Pane> */}
              </Tab.Content>
            </Col>
            <Col lg='12' className='mt-auto'>
              <Nav.Link className='text-danger d-block d-md-none mx-auto d-flex align-items-center' style={{ width: 'fit-content' }} onClick={() => handleDeleteAccount()}>
                <Feather.Trash size={17} className='me-3' /> Delete Account
              </Nav.Link>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </React.Fragment>
  );
};

export default Setting;
